import { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

export default function useUserData() {
  const [user] = useAuthState(auth);
  const [userPlan, setUserPlan] = useState('Gratuito');

  useEffect(() => {
    if (user) {
      const fetchUserPlan = async () => {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            setUserPlan(userDoc.data().plano);
          }
        } catch (error) {
          console.error('Erro ao buscar o plano do usuário:', error);
        }
      };

      fetchUserPlan();
    }
  }, [user]);

  return { user, userPlan };
}
